import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../../Config';

export default function Notifications() {
  const [notifs, setNotifs] = useState(null);

  useEffect(() => {
    const fetchNotifs = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${API_URL}/profile/notifications`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setNotifs(res.data.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchNotifs();
    const interval = setInterval(fetchNotifs, 10000); // Toutes les 10s
    return () => clearInterval(interval);
  }, []);

  if (!notifs) return <div className="text-center py-20">Chargement...</div>;

  return (
    <div className="min-h-screen  py-10">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-10 text-center">Mes Notifications</h1>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-8 text-center">
            <div className="text-5xl font-bold text-yellow-600">{notifs.demandes_en_attente}</div>
            <p className="text-xl mt-4 text-yellow-800">En attente de validation</p>
          </div>

          <div className="bg-green-50 border border-green-200 rounded-xl p-8 text-center">
            <div className="text-5xl font-bold text-green-600">{notifs.demandes_validees}</div>
            <p className="text-xl mt-4 text-green-800">Validées</p>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-xl p-8 text-center">
            <div className="text-5xl font-bold text-blue-600">{notifs.demandes_pretes}</div>
            <p className="text-xl mt-4 text-blue-800">Prêtes à récupérer</p>
          </div>
        </div>
      </div>
    </div>
  );
}